import {createListResponseSchemaDefault} from 'src/feature/bite/domain'
import z from 'zod'

export const StatementListItemSchema = z.object({
  paymentTypeName: z.string().nullable(),
  totalSalesAmount: z.number().nullable(),
  numberOfTransaction: z.number().nullable(),
  commission: z.number().nullable(),
  commissionFee: z.number().nullable(),
  totalDue: z.number().nullable(),
})

export const StatementListSchemaResponse = createListResponseSchemaDefault(
  z.object({
    dataList: z.array(StatementListItemSchema),
  })
)

export type StatementListItem = z.infer<typeof StatementListItemSchema>
export type StatementList = z.infer<typeof StatementListSchemaResponse.shape.response>
export type StatementListResponse = z.infer<typeof StatementListSchemaResponse>

export const listFilterSchema = z.object({
  periodType: z.number(),
  periodMounth: z.number(),
  periodYear: z.number(),
})

export type ListFilter = z.infer<typeof listFilterSchema>
